import script from "./KCircleIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./KCircleIcon.vue?vue&type=script&setup=true&lang=ts"

import "./KCircleIcon.vue?vue&type=style&index=0&id=5bbd3cda&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bbd3cda"]])

export default __exports__